import React from 'react';
import {
  siGo,
  siKubernetes,
  siMongodb,
  siPrometheus,
  siApachekafka,
  siHashicorp,
  siGrafana,
  siAnsible,
  siTerraform,
  siDocker,
  siPython,
  siRedis,
  siApple,
  siGooglecloud
} from 'simple-icons';

import { FaAws, FaNetworkWired, FaCloud } from "react-icons/fa";

interface SkillIconProps {
  iconName: string;
  className?: string;
  size?: number;
}

const createSimpleIcon = (icon: any, className: string, size: number) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} style={{ width: size, height: size }}>
    <path d={icon.path} />
  </svg>
);

const SkillIcon: React.FC<SkillIconProps> = ({ iconName, className = '', size = 24 }) => {
  // Map icon names to icon components
  const iconMap: { [key: string]: any } = {
    'go': siGo,
    'kubernetes': siKubernetes,
    'mongodb': siMongodb,
    'prometheus': siPrometheus,
    'apachekafka': siApachekafka,
    'hashicorp': siHashicorp,
    'grafana': siGrafana,
    'ansible': siAnsible,
    'terraform': siTerraform,
    'docker': siDocker,
    'python': siPython,
    'redis': siRedis,
    'apple': siApple,
    'googlecloud': siGooglecloud,
    'amazonaws': FaAws,
    'distributed': FaNetworkWired,
    'microservices': FaCloud,
  };

  const icon = iconMap[iconName.toLowerCase()];

  // Debug logging
  console.log('SkillIcon debug:', { iconName, iconNameLower: iconName.toLowerCase(), icon, iconMapKeys: Object.keys(iconMap) });

  if (icon) {
    // Check if it's a React component (react-icons) or simple-icon object
    if (React.isValidElement(icon) || typeof icon === 'function') {
      // React component (react-icons)
      const IconComponent = icon;
      return <IconComponent className={className} size={size} />;
    } else {
      // Simple-icon object with path data
      return createSimpleIcon(icon, className, size);
    }
  }

  // Fallback: return a generic icon if the specific icon is not found
  return (
    <div 
      className={`${className} bg-gray-200 rounded flex items-center justify-center text-gray-600 font-bold text-xs`}
      style={{ width: size, height: size }}
    >
      {iconName.charAt(0).toUpperCase()}
    </div>
  );
};

export default SkillIcon; 